import { render, staticRenderFns } from "./PDFDocument.vue?vue&type=template&id=95dfe380&scoped=true"
import script from "./PDFDocument.vue?vue&type=script&lang=js"
export * from "./PDFDocument.vue?vue&type=script&lang=js"
import style0 from "./PDFDocument.vue?vue&type=style&index=0&id=95dfe380&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95dfe380",
  null
  
)

export default component.exports